module.exports = __webpack_public_path__ + "static/media/PH3800_001_Spooky-30sec.e9f56e28.mp3";